import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/**
 * NotFound — proper 404 page.
 *
 * Emits both a Helmet-driven `noindex, nofollow` robots meta AND a
 * `<meta name="prerender-status-code" content="404" />` so the react-snap
 * static prerenderer skips this URL from the generated tree. On real
 * requests, hosting-layer rules should map unknown routes to /404 and
 * return an actual 404 HTTP status (see /app/frontend/README-prerender.md).
 */
export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <div className="max-w-3xl mx-auto px-6 py-40 text-center" data-testid="not-found-page">
      <Helmet>
        <title>Page not found — CloudLab Technologies</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <div className="text-xs font-mono uppercase tracking-[0.2em] text-primary mb-4">404 · {pathname}</div>
      <h1 className="font-heading font-black text-5xl md:text-6xl tracking-tighter">Not found.</h1>
      <p className="mt-4 text-muted-foreground">The page you&apos;re looking for doesn&apos;t exist.</p>
      <Link to="/" className="mt-8 inline-block rounded-full px-6 py-3 bg-primary text-primary-foreground text-sm font-semibold btn-neon">Back home</Link>
    </div>
  );
}
